import MenuGrid from '../../components/MenuGrid/MenuGrid';

const Home = () => {
  return (
    <div>
      <MenuGrid />
    </div>
  );
};

export default Home;
